import apis from '@apis/index';
import ROUTER from '@constants/router';
import { setCurrentAddress, storeAddress } from '@stores/address';
import { myInfoSelector } from '@stores/myInfo';
import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getAddressName } from 'utils/common';

export default function InitAddress({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isAddressInit, setIsAddressInit] = useState(false);
  const { status } = useSession();
  const router = useRouter();
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const { _id, country } = useSelector(myInfoSelector);

  const setInitAddress = async () => {
    if (status === 'loading') return;
    if (router.query?.callbackAddress) {
      const { callbackAddress } = router.query;
      let tempAddress;
      const list = await apis.address.searchGeocode(callbackAddress as string);
      if (list?.addresses && list.addresses.length > 0) {
        const [targetAddress] = list.addresses;
        const _address =
          targetAddress.roadAddress || targetAddress.jibunAddress;
        tempAddress = {
          _id: 'non-member',
          address: _address,
          alias: getAddressName(_address),
          lat: '' + targetAddress.y,
          lng: '' + targetAddress.x,
          detail: '',
          user: 'non-member',
        };
      }
      localStorage.setItem('tempAddress', JSON.stringify(tempAddress));
      dispatch(
        storeAddress({
          currentAddress: tempAddress,
        }),
      );
      setIsAddressInit(true);
      return;
    }
    if (status === 'authenticated') {
      const { address: currentAddress } =
        await apis.address.fetchCurrentAddress();

      if (!currentAddress) {
        const storageAddress = localStorage.getItem('tempAddress');

        if (storageAddress) {
          const tempAddress = JSON.parse(storageAddress || '{}');
          dispatch(
            storeAddress({
              currentAddress: tempAddress,
            }),
          );
        } else {
          router.push({ pathname: ROUTER.address });
        }
      } else {
        dispatch(storeAddress({ address: [], currentAddress }));
      }
    } else {
      const storageAddress = localStorage.getItem('tempAddress');
      let tempAddress = storageAddress ? JSON.parse(storageAddress) : undefined;
      if (!tempAddress) {
        if (router.query?.callbackAddress) {
          const { callbackAddress } = router.query;

          const list = await apis.address.searchGeocode(
            callbackAddress as string,
          );
          if (list.addresses.length > 0) {
            const [targetAddress] = list.addresses;
            const _address =
              targetAddress.roadAddress || targetAddress.jibunAddress;
            tempAddress = {
              _id: 'non-member',
              address: _address,
              alias: getAddressName(_address),
              lat: '' + targetAddress.y,
              lng: '' + targetAddress.x,
              detail: '',
              user: 'non-member',
            };
          }
          localStorage.setItem('tempAddress', JSON.stringify(tempAddress));
        } else {
          router.replace({ pathname: ROUTER.address, query: router.query });
          setIsAddressInit(true);
          return;
        }
      }
      dispatch(setCurrentAddress(tempAddress));
    }
    setIsAddressInit(true);
  };

  const setInitLang = () => {
    if (status === 'loading') return;
    const langQuery = router.query['lang'] as string | undefined;
    if (status === 'unauthenticated') {
      if (langQuery) {
        localStorage.setItem('lang', langQuery ?? 'th');
        i18n.changeLanguage(langQuery ?? 'th');
      } else {
        const storagedLang = localStorage.getItem('lang');
        i18n.changeLanguage(storagedLang ?? 'th');
      }
    } else {
      if (langQuery) {
        localStorage.setItem('lang', langQuery ?? 'th');
        i18n.changeLanguage(langQuery ?? 'th');
      } else if (_id) {
        localStorage.setItem('lang', country ?? 'th');
        i18n.changeLanguage(country ?? 'th');
      }
    }
  };

  useEffect(() => {
    setInitAddress();
  }, [status]);

  useEffect(() => {
    setInitLang();
  }, [status, router, _id]);

  return <>{isAddressInit && children}</>;
}
